const {JustDate} = require('./JustDate')

/**
 * @param {date} date
 * @return {date}
 */
function addUserTimeZone(date) {
    return new JustDate(date)

    const originalDate = date

    if (!(date instanceof Date)) {
        if (!date) {
            return date
        } else {
            date = new Date(date)
        }
    }

    if (!date || isNaN(date.getYear())) {
        return originalDate
    }

    return new Date(date.getTime() +
        60 * 1000 * (new Date()).getTimezoneOffset())
}

/**
 * @param {json} json
 * @return {json}
 */
function addUserTimeZoneJson(json) {
    for (const key in json) {
        if (key.indexOf('date') !== -1) {
            json[key] = addUserTimeZone(json[key])
        } else if (typeof json[key] === 'object') {
            json[key] = addUserTimeZoneJson(json[key])
        }
    }

    return json
}


module.exports = {
    addUserTimeZone,
    addUserTimeZoneJson,
}
